import React from 'react';
import Language from './language';
import SlidingPanel from '../../common/slidingPanel';
import CollapsibleList from '../../common/collapsibleList';
import translate from '../../../utils/translate';

export default class HeaderLanguagePicker extends React.Component {
  static propTypes = {
    languages: React.PropTypes.array,
    currentLanguage: React.PropTypes.object
  };

  renderActiveLanguage = () => {
    const currentLanguageName = this.props.currentLanguage.shortDisplayName;
    return this.props.languages.map(
      lang => currentLanguageName === lang.shortDisplayName ? <Language {...lang} /> : null
    );
  };

  render () {
    const activeLanguage = this.props.languages.filter((lang) => {
      if (lang.shortDisplayName === this.props.currentLanguage.shortDisplayName) {
        return lang;
      }
    });
    const currentLanguageName = activeLanguage[0] ? activeLanguage[0].fullDisplayName : '';
    const selectLanguage = translate('languageModule', 'LANGUAGE');

    const languageList = (
      <CollapsibleList
        title={selectLanguage}
        activeLanguage={currentLanguageName}
        open
        persistState
        persistantStateId={`jsEx-desktop`}
      >
        <ul className="languageList">
          {this.props.languages.map((lang, idx) => {
            const itemClass = lang.shortDisplayName !== this.props.currentLanguage.shortDisplayName
              ? 'languageList-item'
              : 'languageList-item languageList-item--active';
            return (
              <li className={itemClass} key={idx}>
                <a
                  href={lang.link}
                  data-component="languageItemLink"
                  aria-label={lang.fullDisplayName}
                >
                  {lang.fullDisplayName}
                  <span />
                </a>
              </li>
            );
          })}
        </ul>
      </CollapsibleList>
    );
    return (
      <div className="header__language">
        {this.renderActiveLanguage()}
        <SlidingPanel isDesktop children={languageList} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/language/index.js